<div class="base" (click)="baseOnClick()">
    <div class="contenedor" id="contenedor">
        <div class="contenido">
            <!--
                <ul>
                    <li *ngFor="let opc of ddOpciones;index as i">
                        <div (click)="emitirRespuesta(opc)" class="dropdown-button">
                            {{opc}}
                        </div>
                    </li>
                </ul>
                -->
            <!-- Its important that you keep list attribute empty to hide the default dropdown icon and the browser's default datalist -->
            
            <input class="inputdropdown" autocomplete="off" role="dropdownbox" list="" id="ddInput" (focus)="ddInputOnFocus()"
                (input)="ddInputOnInput()" (keydown)="ddInputOnKeydown($event)" (click)="inputOnClick()" placeholder={{ddPlaceholder}}>
            
            <div class="dropdown scroll-hidex-hidey">
                <datalist id="ddDatalist">
                    <option *ngFor="let opc of ddOpciones;index as i" [ngValue]="opc" (click)="emitirRespuesta(i)"
                        class="dropdown-button" [ngStyle]="asignaEstiloOcultar(i)">
                        {{ opc }}
                    </option>
                </datalist>
            </div>
        </div>
    </div>
</div>